/**
 * Extrait les initiales d'un nom complet
 * @param {string} name - Le nom complet (ex: "Jean Paul Dupont")
 * @param {number} maxLetters - Nombre maximum de lettres (par défaut: toutes)
 * @returns {string} Les initiales en majuscules (ex: "JPD")
 */
export const getInitials = (name, maxLetters = null) => {
  if (!name) return "?";

  const initials = name
    .split(" ")
    .filter((word) => word.length > 0) // Filtrer les espaces vides
    .map((word) => word.charAt(0).toUpperCase());

  return maxLetters
    ? initials.slice(0, maxLetters).join("")
    : initials.join("");
};
